import { render } from "./NewPppoePopup.vue?vue&type=template&id=c9ddcdf6&scoped=true"
import script from "./NewPppoePopup.vue?vue&type=script&lang=js"
export * from "./NewPppoePopup.vue?vue&type=script&lang=js"

import "./NewPppoePopup.vue?vue&type=style&index=0&id=c9ddcdf6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\oltcare-front\\olt_care\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9ddcdf6"]])

export default __exports__